import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router';

import './ContinueButton.sass';

const ContinueButton = ({ handleBlocked }: { handleBlocked: (s: boolean) => void }) => {
	const navigate = useNavigate();

	const handleContinue = () => {
		handleBlocked(false);
		navigate('/');
	};

	return (
		<button onClick={handleContinue} id="continue-button">
			<span>
				<FormattedMessage id="continue" />
			</span>
		</button>
	);
};

export default ContinueButton;
